import { Observable } from 'rxjs';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import urlJoin from 'url-join';
import { Injectable } from '@angular/core';
import { CompanyBasicInfo } from './company.model';
import { PayGroup } from '../shared/models/pay-group.model';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class CompanyService {

  constructor(
    private http: HttpClient
  ) { }

  getCompanyBasicInfos(
    tenantId: string,
    page: number,
    perPage: number,
    legalName: string = '',
    fein: string = '',
    companyCode: string = '',
    hasFein: boolean = null
  ): Observable<CompanyBasicInfo[]> {
    let params = (new HttpParams())
      .append('page', String(page))
      .append('per_page', String(perPage));
    if (legalName != null && legalName !== undefined && legalName.length > 0) {
      params = params.append('legalName', legalName);
    }
    if (fein != null && fein !== undefined && fein.length > 0) {
      params = params.append('fein', fein);
    }
    if (companyCode != null && companyCode !== undefined && companyCode.length > 0) {
      params = params.append('companyCode', companyCode);
    }
    if (hasFein !== null) {
      params = params.append('hasFein', hasFein);
    }
    return this.http.get<CompanyBasicInfo[]>(
      this.getUri(tenantId, params, 'basicinfo')
    );
  }

  getPSGCompanyInfos(
    tenantId: string,
    payGroups: PayGroup[] | string[],
    companies: CompanyBasicInfo[] | string[],
    companyCodes: string[],
    feins: string[],
    page: number,
    perPage: number
  ): Observable<CompanyBasicInfo[]> {
    const params = this._getQueryParameters(payGroups, companies, companyCodes, feins, page, perPage);
    return this.http.get<CompanyBasicInfo[]>(
      this.getUri(tenantId, params, 'psgcompanyinfo')
    );
  }

  private _getQueryParameters(
    payGroups: PayGroup[] | string[],
    companies: CompanyBasicInfo[] | string[],
    companyCodes: string[],
    feins: string[],
    pageIndex?: number,
    pageSize?: number): HttpParams {

    const mappedGroups = this._getGroupCodes(payGroups);
    const mappedCompanies = this._getCompanyIds(companies);

    let params = new HttpParams();

    params = this._appendArray(params, 'payGroups', mappedGroups);
    params = this._appendArray(params, 'companyIds', mappedCompanies);
    params = this._appendArray(params, 'companyCodes', companyCodes);
    params = this._appendArray(params, 'feins', feins);

    if (pageIndex !== null || pageSize !== null) {
      params = params.append('page', pageIndex.toString());
      params = params.append('per_page', pageSize.toString());
    }

    return params;
  }

  private _appendArray(
    params: HttpParams, name: string, value: any[]): HttpParams {

    value = value || [];

    if (value.length > 0) {
      return params.append(name, value.join(','));
    }

    return params;
  }

  private _getGroupCodes(payGroups: PayGroup[] | string[]) {
    const mappedGroups = [];

    if (payGroups) {
      for (const p of payGroups) {
        const group = typeof p === 'string' ? p : (p as PayGroup).code;
        mappedGroups.push(group);
      }
    }

    return mappedGroups;
  }

  private _getCompanyIds(companies: CompanyBasicInfo[] | string[]) {
    const mappedCompanies = [];

    if (companies) {
      for (const c of companies) {
        const company = typeof c === 'string' ? c : (c as CompanyBasicInfo).companyId;
        mappedCompanies.push(company);
      }
    }

    return mappedCompanies;
  }

  private getUri(tenantId: string, params: HttpParams, ...pathSegments: string[]) {
    const uri = urlJoin(ROUTE_TOKEN_GATEWAY_URL, `payment/v1/tenants/${encodeURI(tenantId)}/companies`, ... pathSegments);
    return this.appendParams(uri, params);
  }
  private appendParams(uri: string, params: HttpParams): string {
    if (params) {
      uri += '?' + params.toString();
    }
    return uri;
  }

  private IsNullOrEmpty(str: string): boolean {
    return (typeof str === 'string' && str.length === 0) || str === null;
  }
}
